import { get } from '@ember/object';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import { or } from 'ember-truth-helpers';
import LabeledTextArea, {
  type Signature as LabeledTextAreaSignature
} from '../labeled-text-area.gts';
import ValidatedField from '../validated-field.gts';

interface Signature {
  Element: LabeledTextAreaSignature['Element'];
  Args: {
    propertyName: string;
    onChangesetUpdate?: (changeset: EmberChangeset) => void;
    changeset: EmberChangeset;
    errorClass?: string;
    onChange?: () => void;
  } & Partial<
    Pick<
      LabeledTextAreaSignature['Args'],
      | 'labelName'
      | 'isMandatory'
      | 'displaySubText'
      | 'subText'
      | 'rows'
      | 'placeholder'
      | 'isReadOnly'
    >
  >;
}

export default class LabeledTextAreaComponent extends Component<Signature> {
  onChange = (event: Event) => {
    this.args.changeset.set(
      this.args.propertyName,
      (event.target as HTMLTextAreaElement).value
    );
    if (this.args.onChangesetUpdate) {
      this.args.onChangesetUpdate(this.args.changeset);
    }
  };

  <template>
    <ValidatedField
      @propertyName={{@propertyName}}
      @changeset={{@changeset}}
      @errorClass={{or @errorClass 'error-validated-input-display'}}
    >
      <LabeledTextArea
        @labelName={{@labelName}}
        @isMandatory={{@isMandatory}}
        @displaySubText={{@displaySubText}}
        @subText={{@subText}}
        {{! @glint-expect-error }}
        @value={{get @changeset @propertyName}}
        @onChange={{if @onChange @onChange this.onChange}}
        @rows={{@rows}}
        @placeholder={{@placeholder}}
        @isReadOnly={{@isReadOnly}}
        @propertyName={{@propertyName}}
        ...attributes
      />
    </ValidatedField>
  </template>
}
